import * as React from 'react';
import { SVGProps } from 'react';
const EditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.6843 16.1495C1.56868 16.1493 1.45437 16.1251 1.34864 16.0783C1.24291 16.0315 1.14806 15.9633 1.07013 15.8779C0.9908 15.7932 0.930262 15.6927 0.892492 15.583C0.854721 15.4732 0.840571 15.3568 0.850968 15.2412L1.05513 12.9962L10.4868 3.56787L13.4343 6.51454L4.00513 15.942L1.76013 16.1462C1.73492 16.1485 1.70962 16.1496 1.6843 16.1495ZM14.0226 5.92537L11.076 2.9787L12.8435 1.2112C12.9209 1.13372 13.0128 1.07226 13.1139 1.03032C13.2151 0.988382 13.3235 0.966797 13.4331 0.966797C13.5426 0.966797 13.651 0.988382 13.7522 1.03032C13.8533 1.07226 13.9452 1.13372 14.0226 1.2112L15.7901 2.9787C15.8676 3.0561 15.9291 3.148 15.971 3.24917C16.013 3.35033 16.0345 3.45877 16.0345 3.56829C16.0345 3.6778 16.013 3.78624 15.971 3.8874C15.9291 3.98857 15.8676 4.08047 15.7901 4.15787L14.0235 5.92454L14.0226 5.92537Z"
      fill={props.fill ?? '#7C98B6'}
    />
  </svg>
);
export default EditIcon;
